import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { ErrorService } from '@app/common/services/error.service';
import { WrappedHttpErrorResponse } from './wrapped-error';


@Injectable()
export class ErrorsHandler implements ErrorHandler {
  private injector = inject(Injector);

  handleError(error: Error | HttpErrorResponse | WrappedHttpErrorResponse) {
    console.log('[DEBUG ErrorsHandler.handleError] error type:', error?.constructor?.name);
    console.log('[DEBUG ErrorsHandler.handleError] error:', error);
    console.trace('[DEBUG ErrorsHandler.handleError] call stack');
    const errorService = this.injector.get(ErrorService);

    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        errorService.error('No Internet Connection', error);
      } else {
        let message = error.message;

        if (error.status === 0) {
          message = 'An Unknown Error Occurred While Fetching Data.'
        }

        errorService.error(message, error);
      }
    } else if (error instanceof WrappedHttpErrorResponse) {
      errorService.error(error.message, error.error);
    } else {
      errorService.error(error.message, error);

      //todo - this is a client error, so maybe navigate to an 'error' page?
    }
  }
}